<template>
  <div>
    <!--表格栏-->
    <el-table :data="data.list" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange"
              @current-change="handleCurrentChange" v-loading="loading" :element-loading-text="$t('action.loading')"
              :border="border" :stripe="stripe" ref="ktTable" :height="tableHeightKt"
              :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :size="size" :align="align"
              class="table_radius">
      <el-table-column type="selection" width="50" v-if="showBatchDelete & showOperation"></el-table-column>
      <el-table-column label="序号" type="index" v-if="indexShow" show-overflow-tooltip width="50"></el-table-column>
      <el-table-column v-for="column in columns" :header-align="column.headerAlign!==''?column.headerAlign:'center'" :align="column.align==null?'center':column.align"
                       :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
                       :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter"
                       :sortable="column.sortable==null?true:column.sortable">

        <!-- 自定义插槽 -->
        <template slot-scope="scope">
          <slot :name="column.slotName" :row="scope.row" :$index="scope.$index">
            {{ column.formatter ? column.formatter(scope.row, column, scope.row[column.prop], scope.$index) : scope.row[column.prop]
            }}
          </slot>
        </template>
      </el-table-column>

      <!-- 角色(授权管理) -->
      <el-table-column v-if="showPrivilegeBtn" :label="'权限管理'">
        <template slot-scope="scope">
          <kt-button :label="'授权'" :perms="permsEdit" :size="size" @click="handlePrivilege(scope.$index, scope.row)"/>
          <kt-button :label="'部门关联'" :perms="permsEdit" :size="size" @click="handleDept(scope.$index, scope.row)" :disabled="true"/>
          <kt-button :label="'用户关联'" :perms="permsEdit" :size="size" @click="handleUser(scope.$index, scope.row)"/>
        </template>
      </el-table-column>

      <!-- 通用操作按钮 -->
      <el-table-column :label="$t('action.operation')" width="185"  v-if="showOperation" align="center">
        <template slot-scope="scope">
          <el-button icon="el-icon-view" size="mini" circle :title="'查看'" v-if="showViewBtn"
                     @click="handleCommand('view',scope.$index, scope.row)"/>
          <el-button icon="el-icon-edit" size="mini" circle :title="'编辑'" v-if="showEditBtn &&hasPerms(permsEdit)"
                     @click="handleCommand('edit',scope.$index, scope.row)"/>
          <el-button type="danger" icon="el-icon-delete" size="mini" circle :title="'删除'" v-if="showDeleteBtn && hasPerms(permsDelete)"
                     @click="handleCommand('delete',scope.$index, scope.row)"></el-button>

        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:10px;margin-left: 15px">
      <kt-button :label="$t('action.batchDelete')" :perms="permsDelete" :size="size" type="primary"
                 @click="handleBatchDelete()"
                 :disabled="this.selections.length===0" style="float:left;margin-left: 10px"
                 v-if="showBatchDelete & showOperation"  />

      <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="refreshPageRequest"
                     :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                     :total="data.totalCount" :page-sizes="pageSizes" @size-change="handleSizeChange"
                     style="float:right;padding-right: 15px">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import KtButton from "@/views/Core/KtButton"
  import {hasPermission} from '@/permission/index.js'

  export default {
    name: 'KtTable',
    components: {
      KtButton
    },
    props: {
      columns: Array, // 表格列配置
      data: Object, // 表格分页数据
      permsEdit: String,  // 编辑权限标识
      permsDelete: String,  // 删除权限标识

      showPrivilegeBtn: {  // 是否显示授权按钮--仅限角色管理使用
        type: Boolean,
        default: false
      },
      showViewBtn: {  // 是否显示查看按钮
        type: Boolean,
        default: true
      },
      showEditBtn: {  // 是否显示编辑按钮
        type: Boolean,
        default: true
      },
      showDeleteBtn: {  // 是否显示删除按钮
        type: Boolean,
        default: true
      },
      size: { // 尺寸样式
        type: String,
        default: 'mini'
      },
      align: {  // 文本对齐方式
        type: String,
        default: 'left'
      },
      maxHeight: {  // 表格最大高度
        // type: Number,
        // default: 600
      },
      showOperation: {  // 是否显示操作组件
        type: Boolean,
        default: true
      },
      border: {  // 是否显示边框
        type: Boolean,
        default: false
      },
      stripe: {  // 是否显示斑马线
        type: Boolean,
        default: true
      },
      highlightCurrentRow: {  // // 是否高亮当前行
        type: Boolean,
        default: true
      },
      showOverflowTooltip: {  // 是否单行显示
        type: Boolean,
        default: true
      },
      showBatchDelete: {  // 是否显示批量删除组件
        type: Boolean,
        default: true
      },
      formatter: {
        type: Function
      },
      indexShow: {  // 是否显示序号列表
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        // 分页信息
        pageRequest: {
          pageNum: 1,
          pageSize: 10,

        },
        loading: false,  // 加载标识
        selections: [],  // 列表选中列
        pageSizes: globalConfig.pageSizes,
        tableHeightKt: null, //默认表格高度
      }
    },
    methods: {
      // 分页查询
      findPage: function () {
        this.loading = true;
        let callback = res => {
          this.loading = false
        };
        this.$emit('findPage', {pageRequest: this.pageRequest, callback: callback})
      },
      // 选择切换
      selectionChange: function (selections) {
        this.selections = selections;
        this.$emit('selectionChange', {selections: selections})
      },
      // 选择切换
      handleCurrentChange: function (val) {
        this.$emit('handleCurrentChange', {val: val})
      },
      // 换页刷新
      refreshPageRequest: function (pageNum) {
        this.pageRequest.pageNum = pageNum;
        this.findPage();
      },
      handleSizeChange: function (val) {
        this.pageRequest.pageSize = val;
        this.findPage();
      },
      handleCommand: function (command, index, row) {
        if ("edit" === command) {
          this.$emit('handleEdit', {index: index, row: row})

        } else if ("delete" === command) {
          this.delete(row.id)

        } else if ("view" === command) {
          this.$emit('handleView', {index: index, row: row})

        } else {
          this.$emit('handleOther', {row: row})
        }

      },
      //仅限角色管理--授权
      handlePrivilege: function (index, row) {
        this.$emit('handlePrivilege', {index: index, row: row});
      },
      //仅限角色管理--授权
      handleUser: function (index, row) {
        this.$emit('handleUser', {index: index, row: row});
      },
      // 批量删除
      handleBatchDelete: function () {
        let ids = this.selections.map(item => item.id).toString()
        this.delete(ids)
      },
      // 删除操作
      delete: function (ids) {
        this.$confirm('确认删除选中记录吗？', '提示', {
          type: 'warning'
        }).then(() => {
          let params = []
          let idArray = (ids + '').split(',')
          for (var i = 0; i < idArray.length; i++) {
            params.push({'id': idArray[i]})
          }
          this.loading = true
          let callback = res => {
            if (res.code === 200) {
              this.$message({message: '删除成功', type: 'success'})
              this.findPage()
            } else {
              this.$message({message: '操作失败, ' + res.msg, type: 'error'})
            }
            this.loading = false
          }
          this.$emit('handleDelete', {params: params, callback: callback})
        }).catch(() => {
        })
      },
      setGird: function () {

      },
      //权限判断
      hasPerms: function (perms) {
        // 根据权限标识和外部指示状态进行权限判断
        return hasPermission(perms) & !this.disabled
//        return true;
      }
    },
    mounted() {
      this.refreshPageRequest(1);

      this.$nextTick(function () {
        // this.tableHeightKt = window.innerHeight - this.$refs.ktTable.$el.offsetTop - globalConfig.pageOffsetBottom - $(".toolbar").height()-$(".el-tabs__header").height());
        let h = window.innerHeight - this.$refs.ktTable.$el.offsetTop - globalConfig.pageOffsetBottom;
        // console.log("this.h === " + h);
        if ($(".el-tabs__header").length > 0) {
          h = h - $(".el-tabs__header").height();
        }
        // if ($(".toolbar").length > 0) {
        //   h = h - $(".toolbar").height();
        // }
        if (h < 0 || h > 630) {
          // h = 550;
        }
        // console.log("this.tableHeightKt === " + h);
        this.tableHeightKt = h;
      });
    }
  }
</script>

<style scoped>
  .grid-link {
    text-decoration: none;
    color: #409eff;
    cursor: pointer;
  }

  .grid-link:hover {
    color: #f56c6c;
  }
</style>



// WEBPACK FOOTER //
// src/views/Core/KtTable.vue